/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
// import axios from "axios";

// import NewContentList from "./NewContentList";

// import Event202104_contentList from "./Event202104_contentList";
// import parse from "html-react-parser";
//import '../../css/event20210317.css'
//import '../../css/event210521.css'
//import '../../css/event210629.css'
//import '../../css/event210819.css'
import '../../css/event211020.css';
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
// import moment from "moment";
// import Slider from "react-slick";
// import { isMobile } from "react-device-detect";
import $ from 'jquery';
import axios from 'axios';
import fileDownload from 'js-file-download';
import moment from 'moment';

class Event20260209_hunter extends Component {
  state = {};
  componentDidMount = () => {
    this._getWindowSize();
  };
  _getWindowSize = () => {
    $('img[usemap]').rwdImageMaps();
  };
  componentWillUnmount = () => {
    this._isMounted = false;
  };
  _onBack = () => {
    const { history } = this.props;

    history.goBack();
  };
  _go = () => {
    if (
      moment(new Date()).format('YYYY-MM-DD HH:mm:ss') <
      moment('2026-03-26 12:00:00').format('YYYY-MM-DD HH:mm:ss')
    ) {
      alert('3/26(목) 12시부터 구매 가능합니다');
    } else {
      window.open('https://shop.aniplustv.com/exhibition/466');
    }
  };

  render() {
    // const { bannerList, tabIndex, slideIndex } = this.state;
    const { imgUrl } = this.props;
    return (
      <Fragment>
        <div className="event_head">
          <h3>헌텉X헌터</h3>
          <button
            type="button"
            className="btnClose"
            onClick={this._onBack}
            style={{ pointer: 'cursor' }}
          >
            <img src="/img/detail_img/close_1.png" alt="닫기" />
          </button>
        </div>
        <div className="eventCon">
          <Fragment>
            <img
              src={imgUrl + '/img/event/20260209_hunter/HxH-01.png'}
              alt="헌터X헌터"
            />
            <img
              src={imgUrl + '/img/event/20260209_hunter/HxH-02.png'}
              alt="헌터X헌터"
            />
            <img
              src={imgUrl + '/img/event/20260209_hunter/HxH-03.png'}
              alt="헌터X헌터"
            />
            <img
              src={imgUrl + '/img/event/20260209_hunter/HxH-04.png'}
              alt="헌터X헌터"
            />
            <img
              src={imgUrl + '/img/event/20260209_hunter/HxH-05.png'}
              alt="헌터X헌터"
            />
            <img
              src={imgUrl + '/img/event/20260209_hunter/HxH-06.png'}
              alt="헌터X헌터"
            />
            <img
              src={imgUrl + '/img/event/20260209_hunter/HxH-07.png'}
              alt="헌터X헌터"
            />
            <img
              src={imgUrl + '/img/event/20260209_hunter/HxH-08_01.png'}
              alt="헌터X헌터"
            />
            <img
              src={imgUrl + '/img/event/20260209_hunter/HxH-button.png'}
              alt="헌터X헌터"
              style={{ marginTop: 40, cursor: 'pointer', width: 500 }}
              onClick={this._go}
            />
          </Fragment>
        </div>
      </Fragment>
    );
  }
}

export default shopContext(withRouter(Event20260209_hunter));
